import React, { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import TablePaginationBar from './TablePaginationBar';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { BsThreeDots } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import formatDate from '../utils/formatDate';
import { deleterequest, updaterequest } from '../config/url';
import { config } from '../config/config';
import axios from 'axios';

const ConnectRequestTable = ({ data, type }) => {
  const [render, setRender] = useState(null);
  const [currentUsers, setCurrentUsers] = useState(null);
  const [users, setUsers] = useState(data); // List of users
  const [search, setSearch] = useState(''); // Search input value
  const [filter, setFilter] = useState(''); // Filter value
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [usersPerPage] = useState(10); // Number of users per page

  // Pagination
  useEffect(() => {
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    setCurrentUsers(users.slice(indexOfFirstUser, indexOfLastUser));
  }, [render]);

  // Accept request for Request Specialist by user

  const acceptRequest = async (id) => {
    try {
      const res = await axios.put(`${updaterequest}/${id}`, config);
      if (res.status === 200) {
        setUsers((prevState) => {
          return prevState.filter((data) => data._id !== id);
        });
      } else {
        console.log('Could not update request');
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Delete request for Request Specialist by user
  const deleteRequest = async (id) => {
    try {
      const res = await axios.delete(`${deleterequest}/${id}`, config);
      if (res.status === 200) {
        setUsers((prevState) => {
          return prevState.filter((data) => data._id !== id);
        });
      } else {
        console.log('Could not delete request');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // Filter and search
  useEffect(() => {
    let filteredUsers = users;

    if (filter === 'Sort by Name') {
      filteredUsers = users.sort((a, b) =>
        a.user_id.firstName > b.user_id.firstName ? 1 : -1
      );
    } else if (filter === 'Sort by Request Date') {
      filteredUsers = users.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateA - dateB;
      });
    } else if (filter === 'Sort by Focus') {
      filteredUsers = users.sort((a, b) => (a.focus > b.focus ? 1 : -1));
    } else if (filter === 'Sort by Preference') {
      filteredUsers = users.sort((a, b) =>
        a.preference > b.preference ? 1 : -1
      );
    }

    if (search) {
      filteredUsers = filteredUsers.filter((user) =>
        Object.values(user.user_id)
          .join(' ')
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    setUsers(filteredUsers);
    setRender(Math.floor(Math.random() * 10));
  }, [search, filter, data]);

  const navigate = useNavigate();
  return (
    <div className='container'>
      <div className='d-flex justify-content-end align-items-center '>
        <div className='me-2'>
          <input
            type='text'
            className='form-control rounded'
            placeholder='Search User Name'
            style={{ maxWidth: '300px' }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <select
            className='form-select'
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value=''>Select Filter</option>
            <option>Sort by Name</option>
            {type === 'Navigator' ? (
              <option value='Sort by Preference'>Sort by Preference</option>
            ) : (
              <option value='Sort by Focus'>Sort by Focus</option>
            )}
            <option value='Sort by Request Date'>Sort by Request Date</option>
          </select>
        </div>
      </div>
      <div className='bg-white my-4 rounded shadow px-1'>
        <table
          responsive='xl'
          className='table table-hover mb-4'
          style={{ borderCollapse: 'separate', borderSpacing: '0 1rem' }}
        >
          <thead className='bg-light'>
            <tr>
              <th>User</th>
              <th>Specialist</th>
              {type === 'Navigator' ? <th>Preference</th> : <th>Focus</th>}
              <th>State</th>
              <th>Assigned Users</th>
              <th>Request Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers?.map((user) => (
              <tr key={user._id}>
                <td>
                  {user.user_id.firstName}
                  {' ' + user.user_id.lastName}
                </td>
                <td>
                  {user.specialist_id.firstName}
                  {' ' + user.specialist_id.lastName}
                </td>
                {type === 'Navigator' ? (
                  <td>{user.specialist_id.gender}</td>
                ) : (
                  <td>{user.specialist_id.specialisation}</td>
                )}
                <td>{user.specialist_id.state}</td>
                <td>{user.specialist_id.users?.length}</td>
                <td>{formatDate(user.createdAt)}</td>
                <td>
                  <span className='text-success'>Pending</span>
                </td>
                <td>
                  {/* <DropdownButton size='md' id='actions-button' title='Actions'>
                    <Dropdown.Item onClick={() => acceptRequest(user._id)}>
                      Accept
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => deleteRequest(user._id)}>
                      Delete
                    </Dropdown.Item>
                  </DropdownButton> */}
                  <Button
                    variant='secondary'
                    size='md'
                    onClick={() => {
                      console.log('click');
                      // navigate(`/users/${user.id}`);
                    }}
                    class='btn btn-secondary '
                    type='button'
                    id='dropdownMenuButton1'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <BsThreeDots />
                  </Button>
                  <ul
                    class='dropdown-menu'
                    aria-labelledby='dropdownMenuButton1'
                  >
                    <li onClick={() => acceptRequest(user._id)}>
                      <p class='dropdown-item'>Accept</p>
                    </li>
                    <li onClick={() => deleteRequest(user._id)}>
                      <p class='dropdown-item'>Delete</p>
                    </li>
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={users.length}
        rowsPerPage={usersPerPage}
        onPageChange={paginate}
      />
    </div>
  );
};

export default ConnectRequestTable;
